import { render, staticRenderFns } from "./LibrosWalter.vue?vue&type=template&id=429635dc&scoped=true&"
import script from "./LibrosWalter.vue?vue&type=script&lang=js&"
export * from "./LibrosWalter.vue?vue&type=script&lang=js&"
import style0 from "./LibrosWalter.vue?vue&type=style&index=0&id=429635dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429635dc",
  null
  
)

export default component.exports